import { CSSObject } from "@emotion/react";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";

const ARTICLE_MAX_WIDTH = 420;

export const resultsContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "100px",
};

export const loadMoreButtonCss = {
  root: {
    marginTop: "24px",
  },
};

export const searchResultsContainerCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  paddingTop: "1.5rem",
  gap: "0.75rem",

  article: {
    maxWidth: `${ARTICLE_MAX_WIDTH}px`,
  },

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.XS}px)`]: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(auto, 1fr))",
  },

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.SM}px)`]: {
    gridTemplateColumns: "repeat(3, minmax(auto, 1fr))",
  },

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.LG}px)`]: {
    gridTemplateColumns: "repeat(4, minmax(auto, 1fr))",
  },

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.XXL}px)`]: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",

    article: {
      minWidth: `${ARTICLE_MAX_WIDTH}px`,
    },
  },
};
